import React from 'react';

export const PublicIcon = ({ width = 20, height = 20, color = '#5D5D6B' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667ZM3.333 10c0-.508.067-1.008.175-1.483L7.492 12.5v.833c0 .917.75 1.667 1.666 1.667v1.608C5.883 16.192 3.333 13.392 3.333 10Zm11.575 4.5a1.66 1.66 0 0 0-1.583-1.167h-.833v-2.5a.836.836 0 0 0-.834-.833h-5V8.333h1.667a.836.836 0 0 0 .833-.833V5.833h1.667c.917 0 1.667-.75 1.667-1.667v-.341A6.67 6.67 0 0 1 16.667 10a6.66 6.66 0 0 1-1.759 4.5Z"
      fill={color}
    />
  </svg>
);
